// extracted by mini-css-extract-plugin
export var dark = "VideoCard-module--dark--76f08";
export var fadeInAnimation = "VideoCard-module--fadeInAnimation--374ac";
export var img = "VideoCard-module--img--84893";
export var item = "VideoCard-module--item--37ad1";
export var picture = "VideoCard-module--picture--429da";
export var pictureWrapper = "VideoCard-module--pictureWrapper--a2638";
export var tag = "VideoCard-module--tag--7eb83";
export var text = "VideoCard-module--text--6547f";
export var time = "VideoCard-module--time--7d573";
export var title = "VideoCard-module--title--5d9ee";